import Dayjs from 'dayjs';

function headerStyle({row, column, rowIndex, columnIndex}) {return 'font-size:7px;height:27px;background-color:#c0c0c0;padding:0;border-color:#2c3e50;color:#2c3e50;'}
function cellStyle({row, column, rowIndex, columnIndex}) {return 'font-size:7px;padding:0;border-color:#2c3e50;color:#2c3e50;'}
function timeFormatter(row, column, cellValue, index, type) { return cellValue? Dayjs(cellValue).format(type?type:'YYYY-MM-DD'):'';}

export default {headerStyle,cellStyle, timeFormatter}